/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_Info_SaveInputs */

const cs_portals_listing_extra_info_save = /** @type {(inputs: Portals_Listing_Extra_Info_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit stav nabídky`)
};

const en_portals_listing_extra_info_save = /** @type {(inputs: Portals_Listing_Extra_Info_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save portal status`)
};

/**
* | output |
* | --- |
* | "Save portal status" |
*
* @param {Portals_Listing_Extra_Info_SaveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info_save = /** @type {((inputs?: Portals_Listing_Extra_Info_SaveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_Info_SaveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info_save(inputs)
	return cs_portals_listing_extra_info_save(inputs)
});